import { toast } from 'react-toastify';

import { isAppWebview } from 'v2/helpers/isAppWebview';

export class WebNotificationService {
  public permission = 'Notification' in window ? Notification.permission : 'denied';
  private hasNotification = 'Notification' in window;
  private icon = '/img/icon-orbita.jpg';

  public requestPermission = () => {
    if (isAppWebview()) {
      return;
    }

    if (!this.hasNotification) {
      toast.error('Esse navegador não suporta notificações desktop');
      return;
    }

    Notification.requestPermission();
  };

  public newNotification(title: string, description?: string, options?: NotificationOptions, onClick?: () => void) {
    if (this.hasNotification) {
      if (Notification?.permission === 'denied') return;
      const n = new Notification(title, {
        ...options,
        ...{ icon: this.icon, silent: true, body: description || '', tag: title, renotify: true }
      });
      if (onClick) n.onclick = onClick;
    }
  }
}

const webNotificationService = new WebNotificationService();
export default webNotificationService;
